import * as React from "react";
import { toINR } from "../../../../service/numberFormat";
import { marginCoverOrderHeading } from "../../marginConstants";
import { ISortProps } from "../../../../types/components/margin/marginTypes";
import MarginSort from "../../generic/marginSort";
import { marginScrollService } from "../../../../service/marginFiles/marginScrollService";

export interface IMarginCoverOrderTableMobProps {
	tableData: Array<any>;
	filteredData: Array<any>;
	numOfRows: number;
	sortProps: ISortProps;
	setTableData: (tableData: Array<any>) => void;
}

const MarginCoverOrderTableMob: React.FC<IMarginCoverOrderTableMobProps> = props => {
	const scrollBodyRef = React.useRef<HTMLUListElement>(null);
	const fixedBodyRef = React.useRef<HTMLUListElement>(null);
	const scrollHeadRef = React.useRef<HTMLUListElement>(null);

	return (
		<div className="mrgn_co_tbl margin_table_mob">
			<div className="fixed_col">
				<ul className="hdr_row">
					<li className="tr">
						<div className="td">
							<span className="sort_cont Scrip">
								<MarginSort
									sortList={props.filteredData}
									sortedColName={props.sortProps.sortedColumnState.colName}
									sortKey="Scrip"
									onSort={props.sortProps.onSort}
									colName={marginCoverOrderHeading.scrip}
								/>
							</span>
						</div>
					</li>
				</ul>
				<ul className="data_rows" ref={fixedBodyRef}>
					{props.tableData.slice(0, props.numOfRows).map((row, index) => (
						<li className="tr" key={index}>
							<div className="td">
								<span className="Scrip ib" dangerouslySetInnerHTML={{ __html: row.Scrip }}></span>
							</div>
						</li>
					))}
				</ul>
			</div>

			<div className="scrolling_cont">
				<ul className="hdr_row" ref={scrollHeadRef}>
					<li className="tr">
						<div className="td">
							<span className="sort_cont Segment">
								<MarginSort
									sortList={props.filteredData}
									sortedColName={props.sortProps.sortedColumnState.colName}
									sortKey="Segment"
									onSort={props.sortProps.onSort}
									colName={marginCoverOrderHeading.segment}
								/>
							</span>
						</div>
						<div className="td">
							<span className="sort_cont EnterStopLoss">
								<MarginSort
									sortList={props.filteredData}
									sortedColName={props.sortProps.sortedColumnState.colName}
									sortKey="EnterStopLoss"
									onSort={props.sortProps.onSort}
									colName={marginCoverOrderHeading.enterStopLoss}
								/>
							</span>
						</div>
						<div className="td">
							<span className="sort_cont MinimumStopLossMargin">
								<MarginSort
									sortList={props.filteredData}
									sortedColName={props.sortProps.sortedColumnState.colName}
									sortKey="MinimumStopLossMargin"
									onSort={props.sortProps.onSort}
									colName={marginCoverOrderHeading.minimumStopLossMargin}
								/>
							</span>
						</div>
						<div className="td">
							<span className="sort_cont MarginRequirement">
								<MarginSort
									sortList={props.filteredData}
									sortedColName={props.sortProps.sortedColumnState.colName}
									sortKey="MarginRequirement"
									onSort={props.sortProps.onSort}
									colName={marginCoverOrderHeading.marginRequirement}
								/>
							</span>
						</div>
						<div className="td">
							<span className="sort_cont FinalMargin">
								<MarginSort
									sortList={props.filteredData}
									sortedColName={props.sortProps.sortedColumnState.colName}
									sortKey="FinalMargin"
									onSort={props.sortProps.onSort}
									colName={marginCoverOrderHeading.finalMargin}
								/>
							</span>
						</div>
						<div className="td">
							<span className="sort_cont Times">
								<MarginSort
									sortList={props.filteredData}
									sortedColName={props.sortProps.sortedColumnState.colName}
									sortKey="Times"
									onSort={props.sortProps.onSort}
									colName={marginCoverOrderHeading.times}
								/>
							</span>
						</div>
					</li>
				</ul>
				<ul className="data_rows" ref={scrollBodyRef} onScroll={() => marginScrollService(scrollBodyRef, fixedBodyRef, scrollHeadRef)}>
					{props.tableData.slice(0, props.numOfRows).map((row, index) => (
						<li className="tr" key={index}>
							<div className="td">
								<span className="Segment ib">{row.Segment}</span>
							</div>
							<div className="td">
								<span className="EnterStopLoss ib">{toINR(row.EnterStopLoss)}</span>
							</div>
							<div className="td">
								<span className="MinimumStopLossMargin ib">{toINR(row.MinimumStopLossMargin)}</span>
							</div>
							<div className="td">
								<span className="MarginRequirement ib">{toINR(row.MarginRequirement)}</span>
							</div>
							<div className="td">
								<span className="FinalMargin ib">{toINR(row.FinalMargin)}</span>
							</div>
							<div className="td">
								<span className="Times ib">{toINR(row.Times)}</span>
							</div>
						</li>
					))}
				</ul>
			</div>
		</div>
	);
};

export default MarginCoverOrderTableMob;
